import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./styles.css";
import { Landing } from "./Landing";
import { Admin } from "./Admin";
import { Dashboard } from "./Dashboard";
import { Participant } from "./Participant";
import { Ingestion } from "./Ingestion";

const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/admin", element: <Admin /> },
  { path: "/s/:sessionId", element: <Dashboard /> },
  { path: "/s/:sessionId/ingest", element: <Ingestion /> },
  { path: "/join", element: <Participant /> },
  { path: "/join/:code", element: <Participant /> },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);
